/*
 * @Author: Src
 * @Date: 2025-05-21 09:28:49
 * @LastEditTime: 2025-06-20 17:46:49
 * @LastEditors: Src
 * @FilePath: /work-station/src/store/index.ts
 * @Description: 头部注释配置模板
 */
import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types/index';
import permissionModule from './modules/permission';
import pageSizeModule from './modules/pageSize';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    permission: {
      permission: [],
    },
    pageSize: {
      pageSize: [],
    },
  },
  modules: {
    // 在此注册模块
    permission: permissionModule,
    pageSize: pageSizeModule,
  },
};

export default new Vuex.Store<RootState>(store);
